import dateAndTime from "date-and-time";
import SharedPreferences from "./SharedPreferences";
import { STORAGE_KEYS } from "../../data/constant/Constants";

export function formateDate(
  date: Date,
  formatText: string = "DD MMM YYYY hh:mm A"
) {
  return dateAndTime.format(new Date(date), formatText);
}

export function capitalizeFirstLetters(str: string) {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
}

export function showGlobalLoadingView(show: boolean) {
  SharedPreferences.setBoolean(STORAGE_KEYS.SHOW_LOADING, show);
}
